import React from 'react';

export default function About() {
  return (
    <section id="about" className="py-5" style={{ backgroundColor: '#f8fbfc', fontFamily: "'Montserrat', sans-serif", overflow: 'hidden' }}>
      <div className="container py-5">
        <div className="row align-items-center g-5">

          {/* Left Side: Modern Overlapping Image Grid */}
          <div className="col-lg-6 position-relative">
            {/* Main Large Image */}
            <img 
              src="https://images.unsplash.com/photo-1509391366360-2e959784a276?auto=format&fit=crop&w=800&q=80" 
              alt="Solar Panels Plant" 
              className="img-fluid rounded-4 shadow-lg" 
              style={{ width: '85%', objectFit: 'cover', minHeight: '450px', border: '1px solid rgba(0,0,0,0.05)' }}
            />
            
            {/* Secondary Overlapping Image (Bottom Right) */}
            <img 
              src="https://images.unsplash.com/photo-1613665813446-82a78c468a1d?auto=format&fit=crop&w=600&q=80" 
              alt="Solar Engineering" 
              className="position-absolute rounded-4 shadow-lg d-none d-md-block" 
              style={{ 
                width: '55%', 
                bottom: '-10%', 
                right: '0%', 
                border: '8px solid white',
                objectFit: 'cover',
                height: '250px'
              }}
            />

            {/* Floating Trust Badge */}
            <div className="position-absolute top-0 start-0 bg-white rounded-4 shadow-sm p-3 d-flex align-items-center gap-3" style={{ transform: 'translate(-10px, 20px)' }}>
              <div className="bg-warning rounded-circle d-flex justify-content-center align-items-center" style={{ width: '50px', height: '50px' }}>
                {/* Shield SVG Icon */}
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0f2b5b" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                </svg>
              </div>
              <div>
                <h6 className="fw-bolder mb-0" style={{ color: '#0f2b5b' }}>Govt. Approved</h6>
                <small className="text-muted fw-bold">MSME & GST Registered</small>
              </div>
            </div>
          </div>

          {/* Right Side: Professional Text Content */}
          <div className="col-lg-6 mt-5 mt-lg-0 px-lg-5">
            <div className="mb-4">
              <span className="badge bg-warning text-dark px-3 py-2 rounded-pill fw-bold text-uppercase mb-3" style={{ letterSpacing: '1.5px', fontSize: '12px' }}>
                Who We Are
              </span>
              <h2 className="display-5 fw-bolder mb-3" style={{ color: '#0f2b5b' }}>
                Pioneering the Future of <span className="text-warning">Solar Energy</span>
              </h2>
              <div style={{ width: '60px', height: '4px', backgroundColor: '#ffc107', borderRadius: '2px' }}></div>
            </div>
            
            <p className="text-muted mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
              Headquartered in Sector-11, Indira Nagar, Lucknow, <strong>Divine Solar Energy</strong> is a premier enterprise dedicated to robust electric power generation through advanced solar technology. We build solutions that are not just efficient, but sustainable for generations to come.
            </p>
            
            {/* Sleek Bullet Points with Custom SVG Checks (Updated with Divine Solar's Offerings) */}
            <div className="d-flex flex-column gap-3 mb-5">
              {[
                "Premium Rooftop Solar Systems (TATA, Adani, Havells)",
                "High-Efficiency Solar Inverters, Batteries & Pumps",
                "Solar Water Heaters & Smart Street Lighting Solutions"
              ].map((item, index) => (
                <div key={index} className="d-flex align-items-start gap-3">
                  <div className="mt-1">
                    {/* Custom Green Check SVG */}
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#198754" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  </div>
                  <h6 className="fw-bold text-dark mb-0" style={{ fontSize: '1.05rem', lineHeight: '1.5' }}>{item}</h6>
                </div>
              ))}
            </div>

            {/* Management Info Box (Updated) */}
            <div className="bg-white p-4 rounded-4 border shadow-sm" style={{ borderLeft: '5px solid #0f2b5b !important' }}>
              <h6 className="fw-bolder mb-2 text-uppercase text-secondary" style={{ fontSize: '12px', letterSpacing: '1px' }}>
                Under the Leadership of
              </h6>
              <h5 className="fw-bold mb-0" style={{ color: '#0f2b5b' }}>
                Shashi Prakash Srivastava <span className="text-muted fw-normal mx-2">|</span> <span className="fs-6">Director</span>
              </h5>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
}